import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import React, { FC, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import ApiService from "../services/ApiService";
import { InputContainer } from "modus/components/form/input-container/InputContainer";
import { Alert } from "@material-ui/lab";
import { resolveAPIErrorMessage } from "modus/components/error-message/ErrorMessage";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import {ResourceAuthorizer} from "../../authorizer/components/Authorizer";
import {useParams} from "react-router-dom";

export interface NoAuthFormProps {
  deployedUrl?: string;
  deploymentId: string;
  refreshDeployments: () => void;
  deploymentStatus?: string;
  serviceId: string;
}

const allowedMethods = [
  { key: "GET", value: "GET" },
  { key: "POST", value: "POST" },
  { key: "PUT", value: "PUT" },
  { key: "DELETE", value: "DELETE" },
];

const NoAuthForm: FC<NoAuthFormProps> = ({
  deployedUrl,
  deploymentId,
  refreshDeployments,
  deploymentStatus,
    serviceId,
}) => {
  const [path, setPath] = React.useState<string>("");
  const [formMethod, setFormMethod] = React.useState<string>("");

  const {state,  subscribe} = useAsyncAction(() =>
    ApiService.createNoAuthConfiguration(deploymentId, [
      {
        requestVerb: formMethod,
        requestPath: path,
      },
    ])
  );

  const handleSubmit = () => {
    subscribe();
  };

  useEffect(() => {
    if (!refreshDeployments) {
      return;
    } 
    else if(state?.error) {
       setTimeout(() => {
            refreshDeployments();
          }, 500);
     
    }
    else if (state?.loaded && !state?.error) {
      refreshDeployments();
    }
  }, [state.error, state.loaded, refreshDeployments]);
  const intl = useIntl();
  const isNoAuthDisabled = deploymentStatus === "DEPLOYING" ||
              deploymentStatus === "DEPLOY_INITIATED" || !path || !formMethod
                ? true
                : false


  return (
    <>
      <span className="noauthheader">
        <FormattedMessage defaultMessage="Add API resources here that may need to bypass authentication, subscription validation, and gateway checks." />
      </span>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          marginTop: "16px",
          marginBottom: "16px",
          justifyContent: "space-between",
        }}
      >
        <Box style={{ display: "inline-flex" }}>
          <TextField
            id="filled-basic"
            value={
              deployedUrl?.split("api")[0] +
              "..." +
              deployedUrl?.substring(deployedUrl?.length - 8)
            }
            variant="filled"
            disabled
            style={{
              height: "50px",
              marginTop: "2px",
              width: "450px",
            }}
          />
          <InputContainer
            name="noAuthPath"
            data-testid="noauth-path"
            placeholder={intl.formatMessage({
              defaultMessage: "Add Resource",
            })}
            validate={{
              required: false,
            }}
            style={{
              height: "53px",
            }}
            onChange={(event) => {
              setPath((event.target.value).startsWith("/") ? event.target.value : `/${event.target.value}`);
            }}
          ></InputContainer>
        </Box>

        <Box style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <FormControl variant="outlined" style={{ minWidth: "120px" }}>
            <InputLabel id="noauth-methods-label">Method</InputLabel>{" "}
            <Select
              labelId="noauth-methods-label"
              id="noauth-methods"
              value={formMethod}
              label="Method"
              IconComponent={ExpandMoreIcon}
              displayEmpty
              style={{
                height: "56px",
              }}
              onChange={(event) => setFormMethod(event.target.value as string)}
            >
              {allowedMethods.map((method) => (
                <MenuItem key={method.key} value={method.value}>
                  {method.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
            <ResourceAuthorizer action={"update"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
            <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{
              textTransform: "none",
              borderRadius: "4px",
              padding: "8px 24px",
              height: "56px",
              backgroundColor: (!isNoAuthDisabled && path && formMethod) ? "#0063a3" : "#00000042",
            }}
            disabled={
              isNoAuthDisabled 
            }
          >
            <FormattedMessage defaultMessage="Add Path" />
          </Button>
          </ResourceAuthorizer>
        </Box>
        {state?.error && (
          <Alert severity="error" style={{ width: "100%" }}>
            {resolveAPIErrorMessage(state.error)}
          </Alert>
        )}
      </Box>
    </>
  );
};
export default NoAuthForm;
